define('modules/accounts/security/model',['require','exports','module','app','env','base/model'],function (require, exports, module) {
  "use strict";

  var app = require("app");
  var Config = require("env");
  var BaseModel = require("base/model");

  var model = BaseModel.extend({
    defaults: {},
    initialize: function () {
      this.initRequestEvents();
    },
    urlRoot: function () {
      return Config.backendUrl + "/security/group/";
    },
  });

  module.exports = model;
});

